import { MegaphoneGradientIcon, Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { MultiVideoCamera } from 'components/icons';
import { MONTHLY_AD_CREDITS_AMOUNT } from 'constants/pricing';
import { block } from './utils';

export interface ProGrowPlanDescriptionProps {}

const ProGrowPlanDescription: React.FC<ProGrowPlanDescriptionProps> = () => {
  return (
    <div className={block('description')}>
      <Spacer
        space="12px"
        orientation="vertical"
        align="flex-start"
        justify="flex-start"
      >
        <Spacer
          space="16px"
          orientation="horizontal"
          align="center"
          justify="flex-start"
        >
          <MegaphoneGradientIcon width={16} height={16} />

          <Spacer
            space="8px"
            orientation="horizontal"
            align="center"
            justify="space-between"
          >
            <Text variant="label" size="24px" weight={400}>
              ${MONTHLY_AD_CREDITS_AMOUNT}
            </Text>

            <Text variant="p" weight={400}>
              monthly ad credits
            </Text>
          </Spacer>
        </Spacer>

        <Spacer
          space="16px"
          orientation="horizontal"
          align="center"
          justify="flex-start"
        >
          <MultiVideoCamera
            width={16}
            height={12}
            className={block('camera-icon')}
          />

          <Text variant="p" weight={400}>
            + everything in Pro
          </Text>
        </Spacer>

        <Text variant="p" weight={400}>
          (yes, that means Pro is free)
        </Text>
      </Spacer>

      <div className={block('divider')} />
    </div>
  );
};

export default ProGrowPlanDescription;
